import React from "react"
export function Experience(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M6.643 7.864a.654.654 0 011.064-.1l.07.1L9.47 10.82l3.099 1.618c.393.205.456.71.19 1.012l-.09.084-.1.063-3.1 1.618-1.692 2.956a.655.655 0 01-.98.183l-.084-.082-.07-.1-1.693-2.956-3.099-1.619a.655.655 0 01-.19-1.011l.09-.084.1-.064 3.097-1.618 1.695-2.956zM13.65 1.84a.654.654 0 011.078-.104l.07.104 1.188 2.172 2.173 1.19c.378.206.44.693.189.993l-.085.084-.104.07-2.173 1.186-1.188 2.175a.655.655 0 01-.994.19l-.084-.086-.07-.104-1.189-2.174L10.29 6.35a.655.655 0 01-.19-.994l.086-.084.104-.07 2.174-1.189L13.65 1.84z"
        fill="currentColor"
        fillRule="nonzero"
        id="prefix__experience"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
